import React from 'react';
import { Card, CardContent, CardActionArea, Box, Typography, Drawer} from '@mui/material';

import { InfoPage } from './';

import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';

import Button from '@mui/material/Button';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';


const BACKEND_URL = process.env.REACT_APP_BACKEND;

export default function WorkshopCard(data) {

  const url = 'workshops/' + data.workshop.documentId;

  if (!data.workshop.morning_session) {
    data.workshop.availableSpots.morning = '-'
  }

  if (!data.workshop.evening_session) {
    data.workshop.availableSpots.evening = '-'
  }

  if (!data.workshop.location) {
    data.workshop.location = '-';
  }

  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  }

  const DrawerList = (
    <Box sx={{ height: "80vh", width: "80vw", marginLeft: "5vw"}} role="presentation" onClick={toggleDrawer(false)}>
      <InfoPage workshop={data.workshop} />
    </Box>
  );

  return (
    <Card
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}>
      <Drawer sx={{ width: "80vw", alignContent: "center"}} open={open} anchor="bottom" onClose={toggleDrawer(false)}>
        {DrawerList}
      </Drawer>
      <CardActionArea onClick={toggleDrawer(true)} sx={{ flexGrow: 1 }}>
        <CardContent sx={{ flexGrow: 1 }}>
          <Typography gutterBottom sx={{ color: 'text.primary', fontSize: 14 }}>
            {data.workshop.location}
          </Typography>
          <Typography variant="h6" sx={{
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            minHeight: '3.3em',
            width: '100%',
            color: 'text.primary',
            mb: 1.5
          }}>{data.workshop.name}</Typography>
          <Box>
            <Typography variant="p" sx={{
              display: '-webkit-box',
              WebkitLineClamp: 4,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              minHeight: '5em',
              width: '100%',
              color: 'text.primary',
              mb: 1.5
            }}>
              {data.workshop.description}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              height: "100%"
            }}>
            <Typography component={'span'} variant="body2" sx={{
              display: '-webkit-box',
              WebkitLineClamp: 3,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              minHeight: '9em', color: 'text.primary', mb: 1.5
            }}>
              <Box display="flex" alignItems="center" gap={0.25} sx={{ mt: 1 }}><LightModeIcon /> 10.00-12.00 vabu kohti: {data.workshop.availableSpots.morning}</Box>
              <Box display="flex" alignItems="center" gap={0.25} sx={{ mt: 1 }}><DarkModeIcon /> 13.00-14.30 vabu kohti: {data.workshop.availableSpots.evening}</Box>
              <br />
              <Typography gutterBottom sx={{ color: 'text.secondary', fontSize: 14 }}>
                {data.workshop.organization}
              </Typography>
            </Typography>
          </Box>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}